import axios from 'axios';

class OrderService {
    constructor() {
        this.apiToken = 'ZCWJcIuKQY1ZGEX06y5pLPTYsI1zeHqzVPpTjawprVKcSu3jsc4B9U6Bvr6n';
        this.baseUrl = 'https://supersale.pro/api/api/orders';
    }

    async getUserIp() {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            return response.data.ip;
        } catch (error) {
            //console.error('Error fetching user IP address:', error);
            throw error;
        }
    }

    async createCartOrder(userPhone, userName, comment, cart) {
        const userIp = await this.getUserIp();
    
        const headers = {
            'Content-Type': 'application/json',
            'X-Forwarded-For': userIp
        };

        //const comment = cart.map(item => 
        //    `${item.productName}: Период рассрочки: ${item.installmentMonths}\nСреднемесячный платеж: ${item.installment} `
        //).join("\n");

        const priceOnRequestProductIds = new Set([5013, 5014, 5015])
    
        const products = cart.map(item => ({
            offer_id: item.id,
            price: priceOnRequestProductIds.has(item.id) ? 0 : item.price,
            quantity: 1
        }));
    
        const body = {
            api_token: this.apiToken,
            order: {
                phone: userPhone,
                name: userName,
                link: window.location.hostname,
                comment: comment,
                delivery_type_id: 3,
                sender_id: 1,
                products: products
            }
        };
    
        try {
            const response = await axios.post(this.baseUrl, body, { headers });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    

    async createOrder(userPhone, userName, userAddress, productId, productPrice, comment) {
        const userIp = await this.getUserIp();

        const headers = {
            'Content-Type': 'application/json',
            'X-Forwarded-For': userIp
        };

        const priceOnRequestProductIds = new Set([5013, 5014, 5015])

        const body = {
            api_token: this.apiToken,
            order: {
                phone: userPhone,
                name: userName,
                link: `${window.location.hostname}/product/${productId}`,
                comment: `Период рассрочки: ${comment}\nАдрес доставки: ${userAddress}\nСреднемесячный платеж: ${productPrice}`,
                delivery_type_id: 3,
                sender_id: 1,
                products: [
                    {
                        offer_id: productId,
                        price: priceOnRequestProductIds.has(productId) ? 0 : productPrice,
                        quantity: 1
                    }
                ]
            }
        };

        try {
            const response = await axios.post(this.baseUrl, body, { headers });
            return response.data;
        } catch (error) {
            //console.error('Error creating order:', error);
            throw error;
        }
    }

    async createCall(userPhone, userName, msg) {
        const userIp = await this.getUserIp();

        const headers = {
            'Content-Type': 'application/json',
            'X-Forwarded-For': userIp
        };

        const body = {
            api_token: this.apiToken,
            order: {
                phone: userPhone,
                name: userName,
                link: `${window.location.hostname}/about`,
                comment: msg,
                delivery_type_id: 3,
                sender_id: 1,
                products: [
                    {
                        offer_id: 0,
                        price: 0,
                        quantity: 0
                    }
                ]
            }
        };

        try {
            const response = await axios.post(this.baseUrl, body, { headers });
            return response.data;
        } catch (error) {
            //console.error('Error creating order:', error);
            throw error;
        }
    }
}

export default new OrderService();
